import { render, staticRenderFns } from "./CreateBusienssAddressStepper.vue?vue&type=template&id=4f5499d1&"
import script from "./CreateBusienssAddressStepper.vue?vue&type=script&lang=js&"
export * from "./CreateBusienssAddressStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports